module.exports = __webpack_public_path__ + "img/zs9.78fa9a4c.png";